"use strict";

if (!customElements.get("banner-image-component")) {
  customElements.define(
    "banner-image-component",
    class BannerImageComponent extends HTMLElement {
      constructor() {
        super();

        this.scrollRotationFrame = null;
        this.handleThemeScroll = this.queueScrollRotationUpdate.bind(this);
        this.handleThemeResize = this.queueScrollRotationUpdate.bind(this);
      }

      connectedCallback() {
        this.container = this.closest("[data-section-type]");
        this.handleImageAnimation();
        this.handleTitleAnimation();
        this.setupScrollRotation();
      }

      disconnectedCallback() {
        document.removeEventListener("theme:scroll", this.handleThemeScroll);
        document.removeEventListener("theme:resize", this.handleThemeResize);

        if (this.scrollRotationFrame) {
          cancelAnimationFrame(this.scrollRotationFrame);
          this.scrollRotationFrame = null;
        }
      }

      handleTitleAnimation() {
        const title = this.querySelector("[data-banner-title]");

        if (!title || title.classList.contains("text-highlight-wrapper")) return;

        const animatedTitle = title.querySelector("[data-aos]");

        if (!animatedTitle) return;

        const cropper = animatedTitle.closest(".text-reveal__cropper");

        cropper?.classList.add("overflow-hidden");

        window.theme.waitForAnimationEnd(animatedTitle).then(() => {
          cropper?.classList.remove("overflow-hidden");
        });
      }

      handleImageAnimation() {
        const lazyImages = this.querySelector("[data-banner-image]")?.querySelectorAll(".lazy-image");
        const imgInClass = this.container?.classList.contains("img-in");

        if (!lazyImages?.length || imgInClass) return;

        this.container.classList.add("banner--no-cached-images");

        const onTransitionEnd = () => {
          requestAnimationFrame(() => this.container.classList.add("banner--img-loaded"));
          lazyImages[0].removeEventListener("transitionend", onTransitionEnd);
        };

        lazyImages[0].addEventListener("transitionend", onTransitionEnd);
      }

      setupScrollRotation() {
        this.scrollRotateElements = [...this.querySelectorAll("[data-banner-scroll-rotate]")];

        if (!this.scrollRotateElements.length) return;

        this.updateScrollRotations();
        document.addEventListener("theme:scroll", this.handleThemeScroll);
        document.addEventListener("theme:resize", this.handleThemeResize);
      }

      queueScrollRotationUpdate() {
        if (this.scrollRotationFrame) return;

        this.scrollRotationFrame = requestAnimationFrame(() => {
          this.scrollRotationFrame = null;
          this.updateScrollRotations();
        });
      }

      updateScrollRotations() {
        if (!this.scrollRotateElements?.length) return;

        const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const rect = this.getBoundingClientRect();
        const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
        const clampedProgress = Math.max(0, Math.min(1, progress));
        const centeredProgress = (clampedProgress - 0.5) * 2;

        this.scrollRotateElements.forEach((element) => {
          const intensity = Number.parseFloat(element.dataset.bannerScrollRotateIntensity || "18");
          const rotation = (centeredProgress * intensity).toFixed(2);

          element.style.setProperty("--floating-image-rotation-scroll", `${rotation}deg`);
        });
      }
    }
  );
}
